/*
  zl-help-search.js
  Zoomlite Help Centre - client-side FAQ search for sections/zl-help-hub.liquid

  The hub section embeds a JSON index of every ACTIVE help_faq entry
  (<script type="application/json" data-hs-index>). This script scores the
  typed query against question (x3), search terms (x2) and answer text (x1),
  with a bonus for the whole phrase, and renders the best matches as native
  <details> rows under the search box. No network requests, no libraries.
  Matching is word-prefix based ("carton" matches "cartons", "got" does not
  match "forgot") and common filler words (my, the, how, ...) are ignored
  unless the query is nothing but filler.

  Analytics: pushes help_search (debounced) and help_faq_open (source: search)
  to window.dataLayer, matching the theme's existing pattern.

  Changelog:
  2026-10-06 - Initial build for the Help Centre MVP.
*/
(function () {
  function track(name, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      var entry = { event: name };
      for (var k in payload) entry[k] = payload[k];
      window.dataLayer.push(entry);
    } catch (e) {}
  }

  function esc(str) {
    return String(str).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var STOP = ' a an and are at be by can do does for from how i if in is it its me my of on or the to we what when where why will with you your ';
  function tokens(str) {
    var all = str.toLowerCase().replace(/[^a-z0-9\s'-]/g, ' ').split(/\s+/).filter(function (t) { return t.length > 1; });
    var keep = all.filter(function (t) { return STOP.indexOf(' ' + t + ' ') === -1; });
    return keep.length ? keep : all;
  }
  function wordRe(t) {
    return new RegExp('\\b' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  }

  function init(root) {
    if (root.getAttribute('data-hs-ready') === '1') return;
    var input = root.querySelector('[data-hs-input]');
    var results = root.querySelector('[data-hs-results]');
    var idxEl = root.querySelector('script[data-hs-index]');
    if (!input || !results || !idxEl) return;

    var index;
    try { index = JSON.parse(idxEl.textContent); } catch (e) { return; }
    if (!index || !index.length) return;
    root.setAttribute('data-hs-ready', '1');

    var limit = parseInt(root.getAttribute('data-hs-limit'), 10) || 5;
    var contactUrl = root.getAttribute('data-hs-contact') || '';
    var contactLabel = root.getAttribute('data-hs-contact-label') || 'Contact us';
    var emptyText = root.getAttribute('data-hs-empty') || 'No matching answers yet.';
    var pageHandle = root.getAttribute('data-help-page') || '';

    for (var i = 0; i < index.length; i++) {
      var e = index[i];
      e._q = (e.q || '').toLowerCase();
      e._t = (e.t || '').toLowerCase();
      e._p = (e.p || '').toLowerCase();
    }

    function score(e, toks, phrase) {
      var s = 0;
      for (var i = 0; i < toks.length; i++) {
        var re = toks[i].re;
        if (re.test(e._q)) s += 3;
        if (re.test(e._t)) s += 2;
        if (re.test(e._p)) s += 1;
      }
      if (phrase.length > 3) {
        if (e._q.indexOf(phrase) > -1) s += 4;
        if (e._t.indexOf(phrase) > -1) s += 3;
      }
      return s;
    }

    function chevron() {
      return '<span class="zl-hh__r-chev" aria-hidden="true"><svg viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1,1 6,7 11,1"/></svg></span>';
    }
    function arrow() {
      return '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 8h12M9 3l5 5-5 5"/></svg>';
    }

    function render(list, q) {
      var html = '';
      if (!list.length) {
        html = '<p class="zl-hh__r-empty">' + esc(emptyText) +
          (contactUrl ? ' <a href="' + esc(contactUrl) + '" data-zl-help-contact>' + esc(contactLabel) + '</a>' : '') + '</p>';
      } else {
        html += '<p class="zl-hh__r-count">' + list.length + (list.length === 1 ? ' answer' : ' answers') + ' for "' + esc(q) + '"</p>';
        for (var i = 0; i < list.length; i++) {
          var e = list[i].e;
          html += '<div class="zl-hh__r-wrap"><details class="zl-hh__r" data-hs-handle="' + esc(e.h) + '">' +
            '<summary class="zl-hh__r-q"><h3 class="zl-hh__r-text">' + esc(e.q) + '</h3>' + chevron() + '</summary>' +
            '<div class="zl-hh__r-a"><div class="zl-hh__r-body">' + (e.a || '') + '</div>' +
            (e.cl && e.cu ? '<a class="zl-hh__r-cta" href="' + esc(e.cu) + '" data-zl-help-action="' + esc(e.cl) + '">' + esc(e.cl) + arrow() + '</a>' : '') +
            '</div></details></div>';
        }
      }
      results.innerHTML = html;
      results.hidden = false;

      var rows = results.querySelectorAll('details.zl-hh__r');
      for (var r = 0; r < rows.length; r++) {
        rows[r].addEventListener('toggle', function (ev) {
          if (!ev.target.open) return;
          var h = ev.target.querySelector('.zl-hh__r-text');
          track('help_faq_open', { help_page: pageHandle, source: 'search', faq_handle: ev.target.getAttribute('data-hs-handle'), faq_question: h ? h.textContent.trim() : '' });
        });
      }
      var ctas = results.querySelectorAll('[data-zl-help-action]');
      for (var c = 0; c < ctas.length; c++) {
        ctas[c].addEventListener('click', function (ev) {
          track('help_quick_action', { help_page: pageHandle, source: 'search', action_label: ev.currentTarget.getAttribute('data-zl-help-action'), action_url: ev.currentTarget.getAttribute('href') });
        });
      }
      var contact = results.querySelector('[data-zl-help-contact]');
      if (contact) {
        contact.addEventListener('click', function (ev) {
          track('help_contact_click', { help_page: pageHandle, source: 'search', action_url: ev.currentTarget.getAttribute('href') });
        });
      }
    }

    function clear() {
      results.innerHTML = '';
      results.hidden = true;
    }

    function run(q) {
      var phrase = q.toLowerCase();
      var toks = tokens(q).map(function (t) { return { t: t, re: wordRe(t) }; });
      var scored = [];
      for (var i = 0; i < index.length; i++) {
        var s = score(index[i], toks, phrase);
        if (s > 0) scored.push({ e: index[i], s: s });
      }
      scored.sort(function (a, b) { return b.s - a.s; });
      scored = scored.slice(0, limit);
      render(scored, q);
      return scored.length;
    }

    var typeTimer = null;
    var trackTimer = null;
    input.addEventListener('input', function () {
      clearTimeout(typeTimer);
      clearTimeout(trackTimer);
      var q = input.value.trim();
      if (q.length < 2) { clear(); return; }
      typeTimer = setTimeout(function () {
        var n = run(q);
        trackTimer = setTimeout(function () {
          track('help_search', { help_page: pageHandle, search_term: q, result_count: n });
        }, 800);
      }, 120);
    });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { input.value = ''; clear(); }
      if (ev.key === 'Enter') { ev.preventDefault(); var q = input.value.trim(); if (q.length >= 2) run(q); }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-zl-help-search]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    var r = ev.target && ev.target.querySelector ? ev.target.querySelector('[data-zl-help-search]') : null;
    if (r) init(r);
  });
})();
